import { Link } from "react-router-dom";

const ScreenShareModal = () => {
  return (
    <div className={`relative flex flex-col justify-start items-center top-[40px] left-[465px] w-[243.5px] h-[320.75px] text-darkslategray`}>
      <div className={`rounded-mini bg-white shadow-[-10.383894920349121px_-8.495914459228516px_28.32px_rgba(0,_0,_0,_0.35),_12.271876335144043px_11.327885627746582px_28.32px_rgba(0,_0,_0,_0.35)] backdrop-blur-lg absolute inset-0 w-[243.5px] h-[320.75px]`} />
      <img
        className="absolute top-[-9px] left-[16px] w-[13px] h-[10px]"
        alt=""
        src="/arrow.svg"
      />
      <img
        className="absolute top-[160px] left-[241px] w-[9.89px] h-[13.92px]"
        alt=""
        src="/arrow1.svg"
      />
      <div className="z-0 mt-[13px] font-semibold text-yellowgreen w-[135.03px] h-[24.05px]">
        Screen Share
      </div>
      <img
        className="z-0 mt-[5px] w-[245.5px] h-0.25"
        alt=""
        src="/seprator.svg"
      />
      <div className="z-0 my-[15px] text-[10px] mx-3 w-[220px] text-center">
        The highlighted text is your OneScreen Share code. Touch or click on the
        code or the OneScreen Share icon to launch the Share app and wirelessly
        connect your devices. You can also find it in the widgets panel.
      </div>
      <div
        style={{
          borderRadius: "10px",
          overflow: "hidden",
        }}
        className="z-0 rounded-3xs w-[189px] h-[112.75px] object-cover cursor-pointer"
        alt=""
        src="/video-screen@2x.png"
      >
        <iframe
          width="100%"
          height="100%"
          src="https://www.youtube.com/embed/bvIf-ddUXag"
          frameborder="0"
          allow="fullscreen"
        ></iframe>
      </div>
      <img
        className="z-0 mt-[15px] w-[245.5px] h-0.25"
        alt=""
        src="/seprator1.svg"
      />
      <div className="absolute h-[6.86%] w-[62.26%] top-[89.32%] right-[20.54%] bottom-[3.82%] left-[17.2%]">
        <Link to="/network" className="decoration-transparent">
          <div className="absolute h-full w-[47.85%] top-[0%] right-[52.15%] bottom-[0%] left-[0%]">
            <div className="absolute h-full w-full top-[0%] right-[0%] bottom-[0%] left-[0%] rounded-mini bg-lightsteelblue" />
            <div className="absolute text-darkslategray text-[9px] w-full top-[23.33%] left-[0%] inline-block">
              Previous
            </div>
          </div>
        </Link>
        <Link to="/gurusupport" className="decoration-transparent">
          <div className="absolute h-full w-[47.85%] top-[0%] right-[0%] bottom-[0%] left-[52.15%] text-white">
            <div className="absolute h-full w-full top-[0%] right-[0%] bottom-[0%] left-[0%] rounded-[25px] bg-yellowgreen" />
            <div className="absolute text-[9px] w-full top-[20%] left-[0%] inline-block">
              Continue
            </div>
          </div>
        </Link>
      </div>
      <Link to="/home" className="decoration-transparent">
        <img
          className="absolute h-[13px] w-[13px] top-[3%] right-[3%] bottom-[91.58%] left-[91.38%] max-w-full overflow-hidden max-h-full"
          alt=""
          src="/close.svg"
        />
      </Link>
    </div>
  );
};

export default ScreenShareModal;
